import {
  FALLBACK_IMAGE,
  BASE_URL,
  buildSearchDescription,
  buildSearchResultsJsonLd,
  buildBreadcrumbJsonLd
} from '~/utils/seo/jsonLd'

/**
 * 검색결과 페이지 seoMeta 핸들러 (FO)
 * - API 호출 없음 (query param의 searchTerm만 사용)
 * - SearchResultsPage + BreadcrumbList JSON-LD 주입
 */
export default function handleSearch ({ store, route }) {
  const searchTerm = route.query.searchTerm || ''
  if (!searchTerm) { return }

  const canonicalUrl = `${BASE_URL}/ds/dst/SCR_DST_0015?searchTerm=${encodeURIComponent(searchTerm)}`
  const description = buildSearchDescription({ searchTerm })

  const searchResults = buildSearchResultsJsonLd({
    searchTerm,
    url: canonicalUrl
  })

  const breadcrumb = buildBreadcrumbJsonLd([
    { name: '홈', url: BASE_URL },
    { name: '검색결과', url: canonicalUrl }
  ])

  store.commit('seoMeta/set', {
    title: `${searchTerm} 검색결과 - 다이소몰`,
    description,
    ogUrl: canonicalUrl,
    ogImage: FALLBACK_IMAGE,
    ogType: 'website',
    canonical: canonicalUrl,
    mobileUrl: `https://m.daisomall.co.kr/main/ds/dsl/SCR_DSL_0015?searchTerm=${encodeURIComponent(searchTerm)}`,
    h1: `${searchTerm} 검색결과`,
    jsonLd: [searchResults, breadcrumb]
  })
}
